module.exports = __webpack_public_path__ + "img/warning.28dde556.svg";